module.exports = __webpack_public_path__ + "static/media/smb.ae1f939f.jpg";